import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  staff: [],
  loading: false,
  error: null
};

const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setStaff: (state, action) => {
      state.staff = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setStaff, setLoading, setError } = staffSlice.actions;
export default staffSlice.reducer;
